import { useState, useEffect } from 'react';
import throttle from 'lodash.throttle';

const breakpoints = {
  mobile: 320,
  mobileLandscape: 480,
  tablet: 768,
  tabletLandscape: 1009,
  desktop: 1200,
  desktopLarge: 1500,
  desktopWide: 1920,
};

const useBreakpoint = () => {
  const [breakpoint, setBreakpoint] = useState(() => window.innerWidth);

  useEffect(() => {
    const calcInnerWidth = throttle(() => {
      setBreakpoint(window.innerWidth);
    }, 200);
    window.addEventListener('resize', calcInnerWidth);
    return () => window.removeEventListener('resize', calcInnerWidth);
  }, []);

  return [breakpoint, breakpoints];
};
export default useBreakpoint;
